import { IntlProvider } from 'react-intl'
import portalTheme from '../../theme/theme'
import { LOCALE_NL_NL } from '@derolfgroep/intl/lib/constants'
import { labelsForLocale } from '../../../labels/labels'
import flatten from 'flat'
import ThemeProvider from '@derolfgroep/ui-components/src/theme/ThemeProvider'
import { BrowserRouter as Router } from 'react-router-dom'
import AuthProvider from './AuthProvider'
import { QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import PortalRoutes from '../../routes/PortalRoutes'
import { queryClient } from '../../api/queryClient'
import nlDateFns from 'date-fns/locale/nl'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { StyledEngineProvider } from '@mui/material'
import { NotistackProvider } from '@derolfgroep/ui-components/src/components/NotistackProvider/NotistackProvider'

const App = () => (
  <IntlProvider
    messages={flatten(labelsForLocale(navigator.language))}
    locale={navigator.language}
    defaultLocale={LOCALE_NL_NL}
  >
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={portalTheme}>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nlDateFns}>
              <NotistackProvider>
                <Router>
                  <PortalRoutes />
                </Router>
                <ReactQueryDevtools initialIsOpen={false} position="bottom-left" />
              </NotistackProvider>
            </LocalizationProvider>
          </QueryClientProvider>
        </AuthProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </IntlProvider>
)

export default App
